/**
 * Endpoint paths, mirrored 1:1 from openapi.json (Garson API 0.1.0).
 * Paths live here alone so a backend rename is a one-file change.
 */
export const endpoints = {
  health: () => '/health',

  contactLeads: () => '/contact-leads',

  restaurant: (restaurantId: string | number) => `/restaurants/${restaurantId}`,
  restaurantMenu: (restaurantId: string | number) => `/restaurants/${restaurantId}/menu`,
  restaurantRecommendations: (restaurantId: string | number) => `/restaurants/${restaurantId}/recommendations`,
  restaurantBranches: (restaurantId: string | number) => `/restaurants/${restaurantId}/branches`,
  branchTables: (branchId: string | number) => `/branches/${branchId}/tables`,
  menuItem: (itemId: string | number) => `/menu/items/${itemId}`,
  restaurantItem: (slug: string, itemId: string | number) => `/restaurants/${slug}/items/${itemId}`,
  restaurantReviews: (slug: string) => `/restaurants/${slug}/reviews`,

  tableSessions: () =>
    // NOT canonical. The canonical session endpoint is POST /sessions, which
    // takes resolved ids. Kept only because the backend still exposes this.
    '/table-sessions',
  sessions: () => '/sessions',
  session: (sessionId: string) => `/sessions/${sessionId}`,

  orders: () => '/orders',
  order: (orderId: string | number) => `/orders/${orderId}`,
  orderConfirm: (orderId: string | number) => `/orders/${orderId}/confirm`,
  orderCancel: (orderId: string | number) => `/orders/${orderId}/cancel`,
  orderPayments: (publicToken: string) => `/orders/${publicToken}/payments`,
  orderSplitPayments: (publicToken: string) => `/orders/${publicToken}/split-payments`,

  payments: () => '/payments',
  paymentsSplit: () => '/payments/split',
  paymentMockConfirm: (paymentToken: string) => `/payments/${paymentToken}/mock-confirm`,
  paymentShare: (token: string) => `/payments/share/${token}`,
  paymentShareMockConfirm: (shareToken: string) =>
    `/payment-shares/${shareToken}/mock-confirm`,
  splitPayment: (publicToken: string) => `/split-payments/${publicToken}`,

  reviews: () => '/reviews',

  aiChat: () => '/ai/chat',
  aiChatStream: () => '/ai/chat/stream',
  aiVoice: () => '/ai/voice',
  aiTranscribe: () => '/ai/transcribe',
  /** WebSocket, joined against VITE_WS_BASE_URL rather than the HTTP base. */
  aiLive: (sessionToken: string) => `/ai/live/${sessionToken}`,

  adminLogin: () => '/admin/login',
  adminLogout: () => '/admin/logout',
  adminMe: () => '/admin/me',
  adminOrders: () => '/admin/orders',
  adminOrderStatus: (publicToken: string) => `/admin/orders/${publicToken}/status`,
  adminDashboard: () => '/admin/dashboard',
  adminContactLeads: () => '/admin/contact-leads',
  adminReviews: () => '/admin/reviews',
} as const;
